module.exports = __webpack_public_path__ + "img/roll3.23dbcbf5.png";